import { createContext } from 'react';

export type ITableContext = {
  /**
   * When the table is in a flow context, the header will have a divider and a
   * elevated background color.
   */
  inFlow?: boolean;
};

export const TableContext = createContext<ITableContext | undefined>(undefined);
